// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"236":"4326e39a","817":"4326e39a"}[chunkId] + ".css";
};